import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Row,
  Col,
  Menu,
  Dropdown,
} from 'antd';
import _ from 'lodash';
import { getCurrentPath } from 'utils/urlOperations';
import { currentCompanyPresent, currentCompanyName, currentCompanyLogoUrl } from 'utils/company';
import * as CURRENT_USER_ACTIONS from 'actions/currentUser';
import * as NAVBAR from 'modules/styled/navbar';
import POSLogoSmall from 'assets/images/logo-POSpulse.png';
import NavMenu from './partials/NavMenu';

class NavigationBar extends Component {
  constructor(props) {
    super(props);
    const pathname = getCurrentPath(props.location.pathname);

    this.state = {
      selected: pathname,
      showMenu: pathname !== 'companies',
    };

    this.renderDropdown = this.renderDropdown.bind(this);
    this.handleLogoClick = this.handleLogoClick.bind(this);
    this.handleSwitchCompany = this.handleSwitchCompany.bind(this);
  }

  componentDidMount() {
    const { history, loadCurrentUser } = this.props;

    this.registerHistoryListener = history.listen((location) => {
      const selected = getCurrentPath(location.pathname);
      this.setState({ selected, showMenu: location.pathname !== '/companies' });
      window.scrollTo(0, 0);
    });

    loadCurrentUser();
  }

  componentWillUnmount() {
    this.registerHistoryListener();
  }

  handleLogoClick() {
    const { report, history } = this.props;
    const reportSelected = !_.isEmpty(report);
    const endpoint = `/reports${reportSelected ? `/${report.id}` : ''}`;

    if (currentCompanyPresent()) {
      history.push(endpoint);
    } else {
      history.push('/companies');
    }
  }

  handleSwitchCompany() {
    const { history } = this.props;
    history.push('/companies');
  }

  renderDropdown() {
    const { handleSignOut } = this.props;
    return (
      <Menu>
        <Menu.Item key="company-modal" onClick={this.handleSwitchCompany}>
          Switch company
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="logout" onClick={handleSignOut}>
          Logout
        </Menu.Item>
      </Menu>
    );
  }

  render() {
    const { currentUser } = this.props;
    const { selected, showMenu } = this.state;

    return (
      <NAVBAR.Wrapper>
        <Col xs={24} sm={20}>
          <Row>
            <NAVBAR.LogoWrapper xs={24} sm={3}>
              <NAVBAR.Logo
                alt="POS Pulse"
                logo={currentCompanyLogoUrl() || POSLogoSmall}
                onClick={this.handleLogoClick}
              />
            </NAVBAR.LogoWrapper>
            <Col xs={24} sm={21}>
              {showMenu ? (
                <NavMenu selectedKey={selected} />
              ) : null}
            </Col>
          </Row>
        </Col>
        <NAVBAR.UserWrapper
          xs={24}
          sm={4}
        >
          <Dropdown style={{ height: '100%' }} overlay={this.renderDropdown()} trigger={['click']}>
            <NAVBAR.UserDropdown>
              <NAVBAR.UserAvatar>
                { _.get(currentUser, 'symbol') }
              </NAVBAR.UserAvatar>
              <NAVBAR.UserInfo>
                <NAVBAR.UserName>{ _.get(currentUser, 'fullName') }</NAVBAR.UserName>
                {currentCompanyPresent ? (
                  <NAVBAR.UserCompany>{ currentCompanyName() }</NAVBAR.UserCompany>
                ) : null}
              </NAVBAR.UserInfo>
              <NAVBAR.DropdownArrow type="down" />
            </NAVBAR.UserDropdown>
          </Dropdown>
        </NAVBAR.UserWrapper>
      </NAVBAR.Wrapper>
    );
  }
}

NavigationBar.propTypes = {
  handleSignOut: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  report: PropTypes.object.isRequired, // eslint-disable-line
  history: PropTypes.object.isRequired, // eslint-disable-line
  loadCurrentUser: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired, // eslint-disable-line
};

const mapStateToProps = (state) => ({
  report: state.reports.report,
  currentUser: state.currentUser.data,
});

const mapDispatchToProps = {
  loadCurrentUser: CURRENT_USER_ACTIONS.load,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavigationBar));
